export default[
  {
    path: "/mynewa",
    redirect: "/ddeeminelive"
  },
  {
    path: "/my/myReward",
    component:  resolve => require(["../pages/my-info/my-reward.vue"], resolve),
    meta: { title: '我的奖励' },

  },
  {
    path: "/my/withdraw",
    component:  resolve => require(["../pages/my-info/withdraw.vue"], resolve),
    meta: { title: '提现' },

  },
  {
    path: "/my/spokesmanReward",
    component:  resolve => require(["../pages/my-info/spokesman-reward.vue"], resolve),
    meta: { title: '代言人奖励' },

  },
  {
    path: "/my/myCoupon",
    component:  resolve => require(["../pages/my-info/my-coupon.vue"], resolve),
    meta: { title: '我的代金券' },

  },
  {
    path: "/my/myGoshop",
    component:  resolve => require(["../pages/my-info/my-goshop.vue"], resolve),
    meta: { title: '逛店勋章' },

  },
  {
    path: "/my/mySeckill",
    component:  resolve => require(["../pages/my-info/my-seckill.vue"], resolve),
    meta: { title: '我的秒杀',showBottom:true },
  },
  
  {
    path: "/my/myLiveOrder",
    component:  resolve => require(["../pages/my-info/my-live-order.vue"], resolve),
    meta: { title: '我的直播订单' },

  },
  {
    path: "/my/orderDetail",
    component:  resolve => require(["../pages/my-info/order-detail.vue"], resolve),
    meta: { title: '订单详情' },

  },
]